export default __webpack_public_path__ + "static/media/pie-chart.ba5db0f3.svg";